import { SelectionModel } from "@angular/cdk/collections";
import { Injectable } from "@angular/core";

@Injectable({
    providedIn: "root",
})
export class HelpersService {
    constructor() {}

    verificaChecboxMismoPadre(
        selection: SelectionModel<any>,
        valorPadre: number | string,
        campoAFiltrar: string,
        checked: boolean
    ): boolean {
        let flag = true;

        //console.log(selection.selected.length);
        if (checked) {
            for (let index = 0; index < selection.selected.length; index++) {
                if (
                    this.resolve(campoAFiltrar, selection.selected[index]) !==
                    valorPadre
                ) {
                    flag = false;
                    break;
                }
            }
        } else {
            //se revisan entre todos

            const seleccionados = selection.selected;
            selection.selected.forEach((selected) => {
                seleccionados.forEach((s) => {
                    if (
                        this.resolve(campoAFiltrar, s) !==
                        this.resolve(campoAFiltrar, selected)
                    ) {
                        flag = false;
                    }
                });
            });
        }

        return flag;
    }

    resolve(path, obj) {
        return path.split(".").reduce(function (prev, curr) {
            return prev ? prev[curr] : null;
        }, obj || self);
    }
}
